import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ' ', ' ', ';\n'], ['\n  ', ' ', ' ', ';\n']);

import styled from 'styled-components';
import { onClickStyle, truncateStyle, cellStyle } from './constants';

export var TableBodyCell = styled.td(_templateObject, function (props) {
  return onClickStyle(props);
}, function (props) {
  return truncateStyle(props);
}, cellStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/TableCell.js
// module id = 387
// module chunks = 0